import UserNotificationsChange from '#/components/user-preferences/components/notifications-change-form';

const SettingsNotifications = () => (
  <div>
    <UserNotificationsChange />
  </div>
);

export default SettingsNotifications;
